export default function OrderFlow() {
  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            お申込みの流れ
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600">
            簡単3ステップで論文をお届けします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 md:gap-10 relative">
          {/* 矢印（デスクトップのみ） */}
          <div className="hidden md:block absolute top-24 left-1/3 w-1/3 h-0.5 bg-gradient-to-r from-teal-400 to-blue-400">
            <div className="absolute right-0 top-1/2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-12 border-l-blue-400"></div>
          </div>
          <div className="hidden md:block absolute top-24 left-2/3 w-1/3 h-0.5 bg-gradient-to-r from-blue-400 to-teal-600">
            <div className="absolute right-0 top-1/2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-12 border-l-teal-600"></div>
          </div>

          {/* ステップ1 */}
          <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all p-6 sm:p-8 border-2 border-teal-100">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-xl sm:text-2xl">1</span>
            </div>
            
            <div className="mt-6 sm:mt-8 text-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-teal-50 rounded-full flex items-center justify-center">
                <i className="ri-file-search-line text-3xl sm:text-4xl text-teal-600"></i>
              </div>
              
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                見積を申し込む
              </h3>
              
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed text-left">
                論文依頼するフォームから、ご希望の論文情報をお知らせください。<br />専門スタッフが内容を確認し、お見積りをご提示いたします。<br />※お見積もりは無料です。
              </p>
            </div>
          </div>

          {/* ステップ2 */}
          <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all p-6 sm:p-8 border-2 border-blue-100">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-xl sm:text-2xl">2</span>
            </div>
            
            <div className="mt-6 sm:mt-8 text-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-blue-50 rounded-full flex items-center justify-center">
                <i className="ri-bank-card-line text-3xl sm:text-4xl text-blue-600"></i>
              </div>
              
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                決済
              </h3>
              
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed text-left">
                お見積り内容にご納得いただけましたら、クレジットカードでお支払いをお願いいたします。<br />※請求書払い希望の場合は、ご相談ください。
              </p>
            </div>
          </div>

          {/* ステップ3 */}
          <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all p-6 sm:p-8 border-2 border-teal-100">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-teal-600 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-xl sm:text-2xl">3</span>
            </div>
            
            <div className="mt-6 sm:mt-8 text-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-teal-50 rounded-full flex items-center justify-center">
                <i className="ri-mail-send-line text-3xl sm:text-4xl text-teal-600"></i>
              </div>
              
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                納品
              </h3>
              
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed text-left">
                ご入金確認後、迅速に論文を入手しお届けいたします。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 sm:mt-12 md:mt-16 text-center">
          <p className="text-sm sm:text-base text-gray-600 mb-6">
            ご不明な点がございましたら、お気軽にお問い合わせください
          </p>
          <p className="text-sm sm:text-base text-gray-600 mb-6">
            論文の検索・サマリー作成などにつきましては、<br />無料相談・お問い合わせフォームよりお気軽にご連絡ください。
          </p>
        </div>
      </div>
    </section>
  );
}
